const namespace = 'str/base/';

const baseActionNames = {
  START_ACTION: `${namespace}START_ACTION`,
  STOP_ACTION: `${namespace}STOP_ACTION`,
  ERROR_ACTION: `${namespace}ERROR_ACTION`,
  RESET_ERROR_ACTION: `${namespace}RESET_ERROR_ACTION`,
};

export default baseActionNames;
